import React from "react";

/**
 * Renders a headline with a gold-accented final phrase.
 * Splits `title` at the trailing `accent` substring and wraps it in <em>.
 * If `accent` is not at the tail, falls back to plain title.
 */
export const AccentTitle = ({
    title,
    accent,
    className = "",
    accentColor = "#9E7530",
    component: Tag = "h2",
}) => {
    if (!title) return null;
    const a = (accent || "").trim();
    const t = title.trim();
    let main = t;
    let tail = "";
    if (a && t.endsWith(a)) {
        main = t.slice(0, t.length - a.length).trim();
        tail = a;
    }
    return (
        <Tag className={className}>
            {main}
            {tail && (
                <>
                    {" "}
                    <em
                        className="not-italic"
                        style={{ fontStyle: "italic", color: accentColor }}
                    >
                        {tail}
                    </em>
                </>
            )}
        </Tag>
    );
};
